import React from "react";
import ChangePasswordComponent from "@components/User/ChangePassword/ChangePassword";

export default function ChangePasswords() {
  return <ChangePasswordComponent />;
}
